<template>
  <v-container v-editable="blok" class="mt-0 mb-5 py-0">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="10" md="8" >
          <v-sheet class="banner-container pointer" :style="`background-image: url('${blok.image}');`" tile height="200" v-if="blok.hasLink" @click="goto(`/${blok.link.cached_url}`)">
              <v-container class="fill-height">
              <v-row justify="center" align="center">
                  <v-col cols="12" class="text-left">
                      <h2>{{blok.title}}</h2>
                  </v-col>
              </v-row>
              </v-container>
        </v-sheet>
        <v-sheet class="banner-container" :style="`background-image: url('${blok.image}');`" tile height="200" v-else>
            <v-container class="fill-height">
              <v-row justify="center" align="center">
                  <v-col cols="12" class="text-left">
                      <h2>{{blok.title}}</h2>
                  </v-col>
              </v-row>
            </v-container>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
      goto(path) {
          this.$router.push({path: path})
      }
  },
  props: ["blok"]
};
</script>

<style lang="scss" scoped>
@import "./ImageBox.scss";
</style>